
const SectionList = props =>{
    return <ul className={"empList " + (props.section.toLowerCase()==="languages" ? "horizontalList" : "")}>
        {props.data && props.data.map((item, idx)=>{
            return <li key={props.section + idx}>{item}</li>
        })}
    </ul>
}

export default SectionList;